
//****VARIABLES****
//CUSTOM//*********************************

//Cache
let cache = {
    sessionID: '',
    productitle: 'Photo Caption',
    productid: 33043245793332,
    details: {
        orientation: 'square',
        size: '6x6',
        frame: 'noframe',
        layout: 'standardsquare',
        tiles: [],
        text: [
            {
                family: 'Futura',
                color: '#000000',
                weight: 600,
                value: 'CUSTOM TEXT 1',
            },
            {
                family: 'Futura Light',
                color: '#000000',
                weight: 400,
                value: 'Custom Text 2'
            },
            {
                family: 'Futura Light',
                color: '#000000',
                weight: 400,
                value: ''
            }
        ]
    }
};

//Declare options for right menu
let designobj = {
    options: [
        {
            name: 'Size',
            icon: svgsize,
            description: 'Choose from our selection of print sizes. Changing the orientation alters the layout, you can adjust this in the layout tab.',
            variants: [
                {
                    name: 'Size',
                    id: 'size',
                    type: 'select',
                    variations: [
                        {
                            name: 'Orientation',
                            id: 'orientation',
                            options: [
                                {
                                    name: 'Square',
                                    value: 'square'
                                },
                                {
                                    name: 'Portrait',
                                    value: 'portrait'
                                },
                                {
                                    name: 'Landscape',
                                    value: 'landscape'
                                },
                            ]
                        },
                        {
                            name: 'Size',
                            id: 'size',
                            options: [
                                {
                                    name: '6" x 6"',
                                    value: '6x6',
                                    linked: 'square'
                                },
                                {
                                    name: '8" x 8"',
                                    value: '8x8',
                                    linked: 'square'
                                },
                                {
                                    name: '12" x 12"',
                                    value: '12x12',
                                    linked: 'square'
                                },
                                {
                                    name: '16" x 16"',
                                    value: '16x16',
                                    linked: 'square'
                                },
                                {
                                    name: '20" x 20"',
                                    value: '20x20',
                                    linked: 'square'
                                },
                                {
                                    name: '24" x 24"',
                                    value: '24x24',
                                    linked: 'square'
                                },
                                //Portrait
                                {
                                    name: '4" x 6"',
                                    value: '4x6',
                                    linked: 'portrait'
                                },
                                {
                                    name: '5" x 7"',
                                    value: '5x7',
                                    linked: 'portrait'
                                },
                                {
                                    name: '8" x 10"',
                                    value: '8x10',
                                    linked: 'portrait'
                                },
                                {
                                    name: '9" x 12"',
                                    value: '9x12',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '10" x 15"',
                                    value: '10x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 15"',
                                    value: '12x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 16"',
                                    value: '12x16',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '16" x 20"',
                                    value: '16x20',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '18" x 24"',
                                    value: '18x24',
                                    linked: 'portrait'
                                },
                                {
                                    name: '20" x 30"',
                                    value: '20x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 30"',
                                    value: '24x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 36"',
                                    value: '24x36',
                                    linked: 'portrait'
                                },
                                //Landscape
                                {
                                    name: '6" x 4"',
                                    value: '6x4',
                                    linked: 'landscape'
                                },
                                {
                                    name: '7" x 5"',
                                    value: '7x5',
                                    linked: 'landscape'
                                },
                                {
                                    name: '10" x 8"',
                                    value: '10x8',
                                    linked: 'landscape'
                                },
                                {
                                    name: '12" x 9"',
                                    value: '12x9',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 10"',
                                    value: '15x10',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 12"',
                                    value: '15x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: '16" x 12"',
                                    value: '16x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '20" x 16"',
                                    value: '20x16',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '24" x 18"',
                                    value: '24x18',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 20"',
                                    value: '30x20',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 24"',
                                    value: '30x24',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '36" x 24"',
                                    value: '36x24',
                                    linked: 'landscape'
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: 'Framing',
            icon: svgframe,
            description: 'Choose from our selection of frame finishes.',
            variants: [
                {
                    name: 'Frame',
                    id: 'frame',
                    type: 'select',
                    variations: [
                        {
                            name: 'Frame',
                            id: 'frame',
                            options: [
                                {
                                    name: 'No Frame',
                                    value: 'noframe'
                                },
                                {
                                    name: 'Matt Black',
                                    value: 'mattblack'
                                },
                                {
                                    name: 'Matt Silver',
                                    value: 'mattsilver'
                                },
                                {
                                    name: 'Brushed Copper',
                                    value: 'brushedcopper'
                                },
                                {
                                    name: 'Brushed Champagne Gold',
                                    value: 'brushedchampagnegold'
                                },
                                {
                                    name: 'Brushed Steel',
                                    value: 'brushedsteel'
                                },
                                {
                                    name: 'Polished Silver',
                                    value: 'polishedsilver'
                                },
                                {
                                    name: 'Polished Dark Grey',
                                    value: 'darkpolishedgrey'
                                },
                                {
                                    name: 'Black Oak',
                                    value: 'blackoak'
                                },
                                {
                                    name: 'White Oak',
                                    value: 'whiteoak'
                                },
                                {
                                    name: 'Oak',
                                    value: 'oak'
                                },
                                {
                                    name: 'Wenge',
                                    value: 'wenge'
                                },
                            ]
                        },
                    ]
                }
            ]
        },
        {
            name: 'Layout',
            icon: svglayout,
            description: 'Select a design layout from the options below, these change depending on orientation of the print.',
            variants: [
                {},
                {
                    name: 'Layout',
                    id: 'layout',
                    type: 'radio',
                    variations: [
                        //square
                        {
                            name: 'Standard',
                            value: 'standardsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,50.026)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,53.236)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,56.3205)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Standard Text Right',
                            value: 'standardrightsquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,50.0459)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,53.236)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3205)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        {
                            name: 'Text Overlay Centre',
                            value: 'textoverlaycentersquare',
                            extrainfo: 'Recommended min size 6"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'square'
                            }
                        },
                        //portrait
                        {
                            name: 'Standard',
                            value: 'standardportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,50.026)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,53.236)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,56.3205)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Standard Text Right',
                            value: 'standardrightportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,50.0459)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,53.236)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3205)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        {
                            name: 'Text Overlay Centre',
                            value: 'textoverlaycenterportrait',
                            extrainfo: 'Recommended min size 4"x6"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '4x6'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'portrait'
                            }
                        },
                        //Landscape
                        {
                            name: 'Standard',
                            value: 'standardlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,80.5416,50.026)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,72.2724,53.236)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,56.3205)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Standard Text Right',
                            value: 'standardrightlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.06214,0,0,0.855691,-1.35398,3.03007)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.25992e-17,1.03919,-0.935115,5.3368e-17,99.2024,50.0459)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-0.68193,3.78648e-17,92.4369,53.236)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,107.028,56.3205)"> <rect x="28.127" y="26.721" width="0.928" height="11.879"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                        {
                            name: 'Text Overlay Centre',
                            value: 'textoverlaycenterlandscape',
                            extrainfo: 'Recommended min size 6"x4"',
                            validation: {
                                option: 'size',
                                type: 'min',
                                value: '6x4'
                            },
                            icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.35333,0,0,1.12294,-15.4327,-5.99961)"> <rect x="25.551" y="12.219" width="45.596" height="75.3"/> </g> <g transform="matrix(7.27895e-17,1.03919,-0.954959,5.45831e-17,81.1897,-4.42234)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.69259e-17,1.03919,-1.3863,8.09952e-17,95.2777,20.2881)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(7.01713e-17,1.03919,-1.22799,6.81853e-17,90.1071,42.4587)"> <rect x="28.127" y="26.721" width="0.928" height="11.879" style="fill:white;"/> </g> <g transform="matrix(1.12482,0,0,1.12482,-5.42042,-1.90762)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:0.93px;"/> </g> </svg>`,
                            for: {
                                id: 'orientation',
                                val: 'landscape'
                            }
                        },
                    ]
                }
            ]
        },
        {
            name: 'Style/Text',
            icon: svgpalette,
            description: 'Customise the design of the star map such as the background colour or elemetns displayed on the star map.',
            variants: [
                {
                    name: 'Text Options',
                    id: 'text',
                    type: 'text',
                    variations: [
                        {
                            name: 'Line 1',
                            id: 'text1',
                            fontstyle: {
                              fonts: [
                                {
                                  name: "Futura",
                                  weights: [400,600]
                                },
                                {
                                  name: "Futura Light",
                                  weights: [400,600]
                                },
                                {
                                  name: "Dancing Script",
                                  weights: [400,600]
                                },
                                {
                                  name: "Playfair Display",
                                  weights: [400]
                                },
                              ],
                              colours: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                            }
                        },
                        {
                            name: 'Line 2',
                            id: 'text2',
                            fontstyle: {
                              fonts: [
                                {
                                  name: "Futura",
                                  weights: [400,600]
                                },
                                {
                                  name: "Futura Light",
                                  weights: [400,600]
                                },
                                {
                                  name: "Dancing Script",
                                  weights: [400,600]
                                },
                                {
                                  name: "Playfair Display",
                                  weights: [400]
                                },
                              ],
                              colours: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                            }
                        },
                        {
                            name: 'Line 3',
                            id: 'text3',
                            fontstyle: {
                              fonts: [
                                {
                                  name: "Futura",
                                  weights: [400,600]
                                },
                                {
                                  name: "Futura Light",
                                  weights: [400,600]
                                },
                                {
                                  name: "Dancing Script",
                                  weights: [400,600]
                                },
                                {
                                  name: "Playfair Display",
                                  weights: [400]
                                },
                              ],
                              colours: [
                                { name: 'Yellow', value: '#efb702' },
                                { name: 'Orange', value: '#dd7742' },
                                { name: 'Red', value: '#d33b3e' },
                                { name: 'Burgundy', value: '#7f1e17' },
                                { name: 'Fuschia', value: '#d95c80' },
                                { name: 'Blush', value: '#e28a84' },
                                { name: 'Pink', value: '#e79dae' },
                                { name: 'Purple', value: '#6b3687' },
                                { name: 'Eggplant', value: '#421d4a' },
                                { name: 'Pigeon', value: '#9eb3ca' },
                                { name: 'Sky Blue', value: '#9ab5d3' },
                                { name: 'Aqua', value: '#9cd0d3' },
                                { name: 'Turquoise', value: '#52aab3' },
                                { name: 'Royal', value: '#294a94' },
                                { name: 'Blue Jack', value: '#153a51' },
                                { name: 'Midnight', value: '#1a1d29' },
                                { name: 'Grey Blue', value: '#3b4555' },
                                { name: 'Aquamarine', value: '#234955' },
                                { name: 'Cobalt Blue', value: '#141646' },
                                { name: 'Mint', value: '#a5cfae' },
                                { name: 'Forest', value: '#437144' },
                                { name: 'Green Bottle', value: '#214231' },
                                { name: 'Khaki', value: '#616451' },
                                { name: 'Cream', value: '#f4e5ce' },
                                { name: 'Old Paper', value: '#d6bfa0' },
                                { name: 'Clay', value: '#b8a998' },
                                { name: 'Brown', value: '#523527' },
                                { name: 'Duty Blue', value: '#556473' },
                                { name: 'Grey', value: '#a4a4a4' },
                                { name: 'Anthracite', value: '#3b3b3c' },
                                { name: 'Black', value: '#000000' },
                                { name: 'White', value: '#FFFFFF' },
                            ]
                            }
                        },
                    ]
                },
            ]
        },
        /*{
            name: 'Uploads',
            icon: svgphoto,
            description: 'Upload and add photographs to the design individually or use autofill.',
            variants: [
                {
                    name: 'Uploads',
                    id: 'uploads',
                    type: 'uploader',
                    variations: []
                }
            ]
        },*/
    ]
};

//Design Templates
let layouttemplates = [
    //Square templates
    {
        name: 'Standard',
        id: 'standardsquare',
        value: 'standardsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.15,
                left: 0.2,
                width: 0.6,
                height: 0.6
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'bottom',
                    top: 0.65,
                    left: 0.5,
                    originX: 'center',
                    originY: 'bottom',
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                    ]
                }
            ]
        },
    },
    {
        name: 'Standard Right',
        id: 'standardrightsquare',
        value: 'standardrightsquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.1,
                left: 0.1,
                width: 0.8,
                height: 0.7
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'bottom',
                    top: 0.65,
                    left: 0.9,
                    originX: 'right',
                    originY: 'bottom',
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                    ]
                }
            ]
        },
    },
    {
        name: 'Text Overlay Center',
        id: 'textoverlaycentersquare',
        value: 'textoverlaycentersquare',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.1,
                left: 0.1,
                width: 0.8,
                height: 0.8
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'center',
                    top: 0.5,
                    left: 0.5,
                    originX: 'center',
                    originY: 'center',
                    fontsize: 30,
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 30
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 30
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 30
                        },
                    ]
                }
            ]
        },
    },
    //Portrait Templates
    {
        name: 'Standard',
        id: 'standardportrait',
        value: 'standardportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.15,
                left: 0.2,
                width: 0.6,
                height: 0.6
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'bottom',
                    top: 0.65,
                    left: 0.5,
                    originX: 'center',
                    originY: 'bottom',
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                    ]
                }
            ]
        },
    },
    {
        name: 'Standard Text Right',
        id: 'standardrightportrait',
        value: 'standardrightportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.08,
                left: 0.1,
                width: 0.8,
                height: 0.75
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'bottom',
                    top: 0.65,
                    left: 0.9,
                    originX: 'right',
                    originY: 'bottom',
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                    ]
                }
            ]
        },
    },
    {
        name: 'Text Overlay Center',
        id: 'textoverlaycenterportrait',
        value: 'textoverlaycenterportrait',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.1,
                left: 0.1,
                width: 0.8,
                height: 0.8
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'center',
                    top: 0.5,
                    left: 0.5,
                    originX: 'center',
                    originY: 'center',
                    fontsize: 30,
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 30
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 30
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 30
                        },
                    ]
                }
            ]
        },
    },
    //Landscape Templates
    {
        name: 'Standard',
        id: 'standardlandscape',
        value: 'standardlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.15,
                left: 0.2,
                width: 0.6,
                height: 0.55
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'bottom',
                    top: 0.65,
                    left: 0.5,
                    originX: 'center',
                    originY: 'bottom',
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                    ]
                }
            ]
        },
    },
    {
        name: 'Standard Text Right',
        id: 'standardrightlandscape',
        value: 'standardrightlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.1,
                left: 0.08,
                width: 0.84,
                height: 0.65
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'bottom',
                    top: 0.65,
                    left: 0.92,
                    originX: 'right',
                    originY: 'bottom',
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 10
                        },
                    ]
                }
            ]
        },
    },
    {
        name: 'Text Overlay Center',
        id: 'textoverlaycenterlandscape',
        value: 'textoverlaycenterlandscape',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
        layout: {
            photo: {
                top: 0.1,
                left: 0.1,
                width: 0.8,
                height: 0.8
            },
            text: [
                {
                    lines: 3,
                    photoalign: 'center',
                    top: 0.5,
                    left: 0.5,
                    originX: 'center',
                    originY: 'center',
                    fontsize: 30,
                    fonts: [
                        {
                            family: 'Futura',
                            color: '#000000',
                            size: 30
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 30
                        },
                        {
                            family: 'Futura Light',
                            color: '#000000',
                            size: 30
                        },
                    ]
                }
            ]
        },
    },
];